import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Snackbar,
  Alert,
  Avatar,
  DialogContentText,
  Divider,
  Link,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import API from "../../api/API";
import { isValidCurp } from "utils/isValidCurp";
import { useNavigate } from "react-router-dom";
import CardexDialog from "components/CardexDialog";
import { useAuth } from "providers/AuthContextProvider";
import capitalizeFirstLetter from "utils/capitalizeFirstLetter";
import Banners from 'views/banners/Banners';
import AdsBanner from "components/AdsBanner";
import UserDialog from "components/UserDialog";

const links = [
    { label: "About", href: "/about-us" },
    { label: "Help", href: "/help" },
    { label: "API", href: "/api" },
    { label: "Jobs", href: "/about-us" },
    { label: "Privacy", href: "/privacy" },
    { label: "Terms", href: "/terms" },
    { label: "FAQ", href: "/faq" },
    { label: "Contact Us", href: "/contact-us" },
  ];

const Sons = ({ parentId }) => {
    const navigate = useNavigate()
    const { user } = useAuth();
    const [loading, setLoading] = useState(false)
    const [banners, setBanners] = useState([])
    const [sons, setSons] = useState([]);
    const [selectedSon, setSelectedSon] = useState([]);
    const [snackbarState, setSnackbarState] = React.useState({open: false, message: "", status: "info"});
    const [openDialog, setOpenDialog] = useState(false);
    const [openUserDialog, setOpenUserDialog] = useState(false);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [gender, setGender] = useState(null);
    const [secure, setSecure] = useState(null);
    const [civilState, setCivilState] = useState(null);
    const [address1, setAddress1] = useState(null)
    const [selectedStd, setSelectedStd] = React.useState([]);
    const [selectedCdd, setSelectedSdd] = React.useState([]);
    const [selectedSports, setSelectedSports] = React.useState([]);
    const [selectedDrugAllergies, setSelectedDrugAllergies] = React.useState([]);
    const [selectedAllergies, setSelectedAllergies] = React.useState([]);
    const [selectedDisabilities, setSelectedDisabilities] = React.useState([]);
    const [selectedBlood, setSelectedBlood] = React.useState(null);
    const [contacts, setContacts] = useState([ { name: "", relationship: "", phone: "" }]);
    const [columns,setColumns] = React.useState(
        [
            { 
                id: 'name', 
                label: 'Nombre', 
                defaultValue:  null,
                required: true,
                type:"text",
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:3,
                xl:4,
            },
            { 
                id: 'last_name', 
                label: 'Apellido paterno', 
                defaultValue: null,
                required: true,
                type:"text",
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:4,
                xl:4,
            },
            {
                id: 'maternal_surname',
                label: 'Apellido materno',
                defaultValue: null,
                type:'text',
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:4,
                xl:4,
            },
            {
                id: 'birth_date',
                label: 'Fecha de nacimiento',
                defaultValue: null,
                required: true,
                type:'date',
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:4,
                xl:4,
            },
            {
                id: 'telephone',
                label: 'Telefono de contacto',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:5, 
                md:5,
                lg:5,
                xl:5,
            },
            {
                id: 'gender',
                label: 'Genero',
                defaultValue: null,
                required: true,
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:3,
                xl:3,
                options:['Masculino', 'Femenino']
            },
            {
                id: 'secure',
                label: 'Seguro medico',
                defaultValue: null,
                required: true,
                disabled:false,
                xs:12, 
                sm:5, 
                md:5,
                lg:5,
                xl:5,
                options:['IMSS', 'ISSTE', 'Privado', 'Ninguno']
            },
            {
                id: 'secureNumber',
                label: 'Numero de medico',
                defaultValue: null,
                required: true,
                disabled: false,
                xs:12, 
                sm:5, 
                md:5,
                lg:5,
                xl:5,
            },
            {
                id: 'sexually_transmitted_disease',
                label: 'Enfermedades de transmicion sexual',
                defaultValue: null,
                required: true,
                disabled:false,
                xs:12, 
                sm:7, 
                md:7,
                lg:7,
                xl:7,
                options: ['Ninguna', 'VIH/SIDA', 'Sífilis', 'Gonorrea', 'Clamidia', 'Herpes genital', 'Virus del Papiloma Humano (VPH)', 'Tricomoniasis', 'Hepatitis B', 'Hepatitis C', 'Linfogranuloma venéreo (LGV)', 'Chancro blando', 'Granuloma inguinal', 'Molusco contagioso', 'Uretritis no gonocócica', 'Vaginosis bacteriana', 'Otros']
            },
            {
                id: 'chronic_degenerative_diseases',
                label: 'Enfermedades generativas cronicas',
                defaultValue: null,
                required: true,
                disabled:false,
                xs:12, 
                sm:7, 
                md:7,
                lg:7,
                xl:7,
                options:['Ninguna', 'Diabetes mellitus tipo 2', 'Hipertensión arterial', 'Enfermedad renal crónica', 'Enfermedades cardiovasculares', 'Cáncer (mama, próstata, cervicouterino, pulmón, colon)', 'Obesidad y sobrepeso', 'Enfermedad pulmonar obstructiva crónica (EPOC)', 'Artritis reumatoide', 'Osteoartritis', 'Asma crónica', 'Demencias (como Alzheimer)']
            },
            {
                id: 'sport',
                label: 'Pratica algun deporte',
                defaultValue: null,
                required: true,
                disabled:false,
                xs:12, 
                sm:5, 
                md:5,
                lg:5,
                xl:5,
                options: ['Ninguno', 'Fútbol', 'Básquetbol', 'Béisbol', 'Boxeo', 'Lucha libre', 'Natación', 'Atletismo', 'Ciclismo', 'Voleibol', 'Tenis', 'Frontón', 'Taekwondo', 'Gimnasia', 'Karate', 'Skateboarding', 'Charrería', 'Artes marciales mixtas (MMA)', 'Senderismo', 'Escalada', 'Golf']
            },
            {
                id: 'otherSport',
                label: 'Otro (escribelo)',
                defaultValue: null,
                required: true,
                disabled: false,
                xs:12, 
                sm:5, 
                md:5,
                lg:5,
                xl:5,
            },
            {
                id: 'age',
                label: 'Edad',
                defaultValue:  null,
                required: true,
                type:'number',
                disabled:false,
                xs:12, 
                sm:2, 
                md:2,
                lg:2,
                xl:2,
            },
            {
                id: 'weight',
                label: 'Peso en KG',
                defaultValue:  null,
                required: true,
                type:'number',
                disabled:false,
                xs:12, 
                sm:3, 
                md:3,
                lg:3,
                xl:3,
            },
            {
                id: 'height',
                label: 'Altura en CM',
                defaultValue:  null,
                required: true,
                type:'number',
                disabled:false,
                xs:12, 
                sm:3, 
                md:3,
                lg:3,
                xl:3,
            },
            {
                id: 'cellphone',
                label: 'Celular',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:4, 
                md:4,
                lg:4,
                xl:4,
            },
            {
                id: 'curp',
                label: 'CURP',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:6, 
                md:6,
                lg:6,
                xl:6,
            },
            {
                id: 'civil_state',
                label: 'Estado civil',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:4, 
                md:4,
                lg:4,
                xl:4,
                options:['Soltero/a', 'Casado/a', 'Unión libre', 'Divorciado/a', 'Viudo/a', 'Separado/a']
            },
            {
                id: 'drug_allergy',
                label: 'Alergia a farmacos',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:4, 
                md:4,
                lg:4,
                xl:4,
                options: ['Ninguna', 'Penicilina', 'Amoxicilina', 'Cefalosporinas', 'Sulfonamidas', 'Aspirina (ácido acetilsalicílico)', 'Ibuprofeno', 'Paracetamol', 'Antiinflamatorios no esteroides (AINEs)', 'Anestésicos locales (como lidocaína)', 'Anticonvulsivos (como fenitoína o carbamazepina)', 'Contrastes yodados', 'Vacunas', 'Otros']
            },
            {
                id: 'common_allergies',
                label: 'Alergias',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:4, 
                md:4,
                lg:4,
                xl:4,
                options: ['Ninguna', 'Polen', 'Ácaros del polvo', 'Polvo', 'Caspa de perro', 'Caspa de gato', 'Picadura de abeja', 'Lácteos', 'Gluten', 'Mariscos', 'Cacahuates', 'Nueces', 'Frutas (como plátano o fresa)', 'Moho', 'Medicamentos', 'Látex', 'Otros']
            },
            {
                id: 'disabilities',
                label: 'Discapacidades',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:4, 
                md:4,
                lg:4,
                xl:4,
                options:['Ninguna', 'Discapacidad visual', 'Discapacidad auditiva', 'Discapacidad motriz', 'Discapacidad intelectual', 'Discapacidad psicosocial (mental)', 'Discapacidad del habla o lenguaje', 'Discapacidad múltiple', 'Autismo o espectro autista', 'Síndrome de Down', 'Parálisis cerebral', 'Otros']
            },
            {
                id: 'blood_type',
                label: 'Tipo de sangre',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:3, 
                md:3,
                lg:3,
                xl:3,
                options:['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'],
            },
            {
                id: 'address_1',
                label: 'Direccion por codigo postal',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:8, 
                md:8,
                lg:8,
                xl:8,
            },
            {
                id: 'address_2',
                label: 'Calle y numero',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:8, 
                md:8,
                lg:8,
                xl:8,
            },
            {
                id: 'emergency_contacts',
                label: 'Contactos de emergencia',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:12,
                xl:12,
            },
        ]
    );
    const [columnsUser,setColumnsUser] = React.useState(
        [
            { 
                id: 'name', 
                label: 'Nombre', 
                defaultValue:  null,
                required: true,
                type:"text",
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:3,
                xl:4,
            },
            { 
                id: 'last_name', 
                label: 'Apellido paterno', 
                defaultValue: null,
                required: true,
                type:"text",
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:4,
                xl:4,
            },
            {
                id: 'maternal_surname',
                label: 'Apellido materno',
                defaultValue: null,
                type:'text',
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:4,
                xl:4,
            },
            {
                id: 'email',
                label: 'Correo electronico',
                defaultValue: null,
                type:'email',
                disabled:false,
                xs:12, 
                sm:12, 
                md:12,
                lg:4,
                xl:4,
            },
            {
                id: 'telephone',
                label: 'Telefono de contacto',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:5, 
                md:5,
                lg:5,
                xl:5,
            },
            {
                id: 'curp',
                label: 'CURP',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:6, 
                md:6,
                lg:6,
                xl:6,
            },
            {
                id: 'password',
                label: 'Contraseña',
                defaultValue:  null,
                required: false,
                type:'text',
                disabled:false,
                xs:12, 
                sm:6, 
                md:6,
                lg:6,
                xl:6,
            },
        ]
    );

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };
    const handleOpenUserDialog = () => {
        setOpenUserDialog(true);
    };
    const handleCloseDialog = () => {
        setOpenDialog(false);
    };
    const handleCloseUserDialog = () => {
        setOpenUserDialog(false);
    };


    const handleChangeStd= (event) => {
        const {
        target: { value },
        } = event;
        setSelectedStd(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeCdd= (event) => {
        const {
        target: { value },
        } = event;
        setSelectedSdd(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeSports= (event) => {
        const {
        target: { value },
        } = event;
        setSelectedSports(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeDrugAllergies= (event) => {
        const {
        target: { value },
        } = event;
        setSelectedDrugAllergies(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeAllergies = (event) => {
        const {
        target: { value },
        } = event;
        setSelectedAllergies(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeDisabilities = (event) => {
        const {
        target: { value },
        } = event;
        setSelectedDisabilities(typeof value === 'string' ? value.split(',') : value);
    };
    const handleChangeSecure = (event)=>{
        setSecure(event.target.value)
    }
    const handleChangeGender = (event)=>{
        setGender(event.target.value)
    }
    const handleChangeBlood = (event)=>{
        setSelectedBlood(event.target.value)
    }
    const handleChangeCivilState = (event)=>{
        setCivilState(event.target.value)
    }
    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarState({open:false,message:snackbarState.message,status:snackbarState.status})
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        // 1. Declarar variables del formulario
        const name = data.get('name');
        const lastName = data.get('last_name');
        const maternalSurname = data.get('maternal_surname');
        const birthDate = data.get('birth_date');
        const telephone = data.get('telephone');
        const cellphone = data.get('cellphone');
        const secureNumber = data.get('secureNumber');
        const otherSport = data.get('otherSport');

        const age = data.get('age');
        const weight = data.get('weight');
        const height = data.get('height');
        const curp = data.get('curp');
        const address2 = data.get('address_2');
        //const emergencyContacts = data.get('emergency_contacts');

        // 2. Validaciones básicas
        if (!isValidCurp(curp)) {
            setSnackbarState({
                open: true,
                message: "Proporciona un CURP válido",
                status: "warning",
            });
            return;
        }

        if (!name || !lastName || !birthDate) {
            setSnackbarState({
                open: true,
                message: "Nombre, apellido y fecha de nacimiento son obligatorios",
                status: "warning",
            });
            return;
        }

        // 3. Construir el requestBody
        const requestBody = {
            parent_id: parentId,
            name: name,
            last_name: lastName,
            maternal_surname: maternalSurname,
            birth_date: birthDate,
            telephone: telephone,
            cellphone: cellphone,
            gender: gender,
            secure: secure, //yQymKoaVYlQR3PD2Pde0
            secureNumber: secureNumber,
            sexually_transmitted_disease: selectedStd,
            chronic_degenerative_diseases: selectedCdd,
            sport: selectedSports,
            otherSport: otherSport,
            age: Number(age),
            weight: Number(weight),
            height: parseFloat(height),
            curp: curp,
            civil_state: civilState,
            drug_allergy: selectedDrugAllergies,
            common_allergies: selectedAllergies,
            disabilities: selectedDisabilities,
            blood_type: selectedBlood,
            medical_history: null,
            address: address2+' '+address1,
            emergency_contacts: contacts,
        };

        // 4. Enviar petición
        setLoading(true)
        const response = await API.postCardex(requestBody);
        setLoading(false)

        if (response.status === 200) {
            setSnackbarState({
                open: true,
                message: response.message,
                status: "success",
            });
            handleCloseDialog(); // Cierra modal si existe
            getSons()
        } else {
            setSnackbarState({
                open: true,
                message: response.message || "Error inesperado",
                status: "error",
            });
        }

    };
    const handleUserSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        // 1. Declarar variables del formulario
        const name = data.get('name');
        const lastName = data.get('last_name');
        const maternalSurname = data.get('maternal_surname');
        const telephone = data.get('telephone');
        const curp = data.get('curp');
        const email = data.get('email');
        const password = data.get('password');

        // 2. Validaciones básicas
        if (!isValidCurp(curp)) {
            setSnackbarState({
                open: true,
                message: "Proporciona un CURP válido",
                status: "warning",
            });
            return;
        }

        if (!name || !lastName || !maternalSurname) {
            setSnackbarState({
                open: true,
                message: "Nombre, apellidos son obligatorios",
                status: "warning",
            });
            return;
        }

        // 3. Construir el requestBody
        const requestBody = {
            parent_id: user.id,
            name: name,
            last_name: lastName,
            maternal_surname: maternalSurname,
            telephone: telephone,
            curp: curp,
            email: email,
            password: password
        };

        // 4. Enviar petición
        setLoading(true)
        const response = await API.postSon(requestBody);
        setLoading(false)

        if (response.status === 200) {
            setSnackbarState({
                open: true,
                message: response.message,
                status: "success",
            });
            handleCloseDialog(); // Cierra modal si existe
            getSons()
        } else {
            setSnackbarState({
                open: true,
                message: response.message || "Error inesperado",
                status: "error",
            });
        }

    };

    const onClickSon = (data)=>{
        //navigate("/cardex",{state:data})
         getCardex(data)
    }
    const handleDeleteClick = (e, reg) => {
        e.stopPropagation(); // Prevents triggering the CardActionArea click
        setOpenDialogDelete(true);
        setSelectedSon(reg)
    };
    const handleConfirmDelete = () => {
        deleteSon();
        setOpenDialogDelete(false);
    };
    const handleCancel = () => {
        setOpenDialogDelete(false);
    };

    useEffect(()=>{
        getSons()
        getBanners()
    },[])

    useEffect(()=>{
    })

    const getBanners = async()=>{
        const response = await API.getBanners()
        if(response.status == 200){
            setBanners(response.data)
            setSnackbarState({open:true, message: response.message, status: "success"})

        }else{
            setSnackbarState({open:true, message: response.message, status: "error"})
        }
    }
    const getSons = async()=>{
        const queryParams = {
            parent_id: parentId
        }
        const response = await API.getSon(queryParams)
        
        if(response.status == 200){
            setSons(response.data)
            setSnackbarState({open:true, message: response.message, status: "success"})

        }else{
            setSnackbarState({open:true, message: response.message, status: "error"})
        }
    }
    const deleteSon = async(reg)=>{
        const queryParams = {
            id: selectedSon.id
        }
        const response = await API.deleteSon(queryParams)
        
        if(response.status == 200){
            setSons(response.data)
            setSnackbarState({open:true, message: response.message, status: "success"})

        }else{
            setSnackbarState({open:true, message: response.message, status: "error"})
        }
    }
    const getCardex = async(data)=>{
        const userId =  data.id
        const queryParams = {
            user_id: userId
        }
        const response = await API.getCardex(queryParams)
        
        if(response.status == 200){
            navigate("/cardex",{state: response.data[0]})
        }else{
            setSnackbarState({open:true, message: "No se econtraron registros (agrega tu cardex)", status: "error"})
            handleOpenDialog()
        }
    }

    return (
        <>
            <Grid container spacing={2} columns={12} sx={{ p: 2}}> 
                <Grid item xs={6} sm={6} md={6}>
                    <Typography variant="body">
                        Modulo para agregar tutorados.
                    </Typography>
                </Grid>
            </Grid>

            <Grid container spacing={2} columns={12} sx={{ p: 2}}> 
                <Grid item xs={9} sm={9} md={9}>
                    <Stack spacing={4} sx={{mx:16}}>
                        <Box
                            sx={{
                                display: "flex",
                                gap: 2,
                                overflowX: "auto",
                                paddingY: 2,
                                whiteSpace: "nowrap",
                                "&::-webkit-scrollbar": { display: "none" }, // Ocultar scroll bar
                            }}
                        >
                            {/* 🔵 Botón de agregar */}
                            <Box >
                                <Box
                                    onClick={handleOpenUserDialog}
                                    sx={{
                                        width: 128,
                                        height: 128,
                                        borderRadius: "50%",
                                        border: "2px dashed #ccc",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        textAlign: "center" 
                                    }}
                                >
                                    <AddIcon sx={{ fontSize: 32, color: "#999" }} />
                                </Box>
                                <Typography variant="caption" sx={{ mt: 1, display: "block" }}>
                                    Agregar hijo
                                </Typography>
                            </Box>

                            {/* 🔵 Lista de hijos en círculos */}
                            {sons?.map((reg, idx) => (
                                <Box key={reg.id || idx} sx={{ textAlign: "center", position: "relative" }}>
                                {/* Avatar circular */}
                                <Box
                                    onClick={() => onClickSon(reg)}
                                    sx={{
                                    width: 128,
                                    height: 128,
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    border: "3px solid #ccc",
                                    position: "relative",
                                    }}
                                >
                                    {/* Si tienes foto → úsala. Sino → iniciales */}
                                    <Avatar
                                        sx={{ width: "100%", height: "100%", fontSize: 26 }}
                                        src={reg.image_url || ""}
                                    >
                                        {reg.name?.[0]}
                                        {reg.last_name?.[0]}
                                    </Avatar>

                                    {/* Botón eliminar (parte superior derecha) 
                                    <IconButton
                                    size="small"
                                    onClick={(event) => handleDeleteClick(event, reg)}
                                    sx={{
                                        position: "absolute",
                                        top: -5,
                                        right: -5,
                                        backgroundColor: "#fff",
                                        boxShadow: 1,
                                        ":hover": { backgroundColor: "#eee" },
                                    }}
                                    >
                                    <DeleteIcon fontSize="small" />
                                    </IconButton>*/}
                                </Box>
                                {/* Nombre abajo */}
                                <Typography
                                    variant="caption"
                                    sx={{
                                    maxWidth: 90,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "block",
                                    mt: 1,
                                    }}
                                >
                                    {(reg.name + " " + reg.last_name).toUpperCase()}
                                </Typography>
                                </Box>
                            ))}
                        </Box>
                        <Banners banners={banners} height={'400px'}card={false} rights={false}></Banners>
                    </Stack>
                </Grid>
                <Grid item xs={3} sm={3} md={3}>
                    <Stack spacing={2}>
                        <Stack
                            direction={'row'}
                            alignItems="center"
                            spacing={1}
                        >
                            <Avatar
                                alt={user.name}
                                src={user.image_url}
                                sx={{ width: 48, height: 48 }}
                            />
                            <Stack spacing={0.3} alignItems="left">
                                <Typography variant="subtitle"  sx={{fontWeight:"bolder"}} >{capitalizeFirstLetter(user.name)} {capitalizeFirstLetter(user.last_name)}</Typography> 
                                <Typography variant="caption">{user?.curp?.toUpperCase()}</Typography>
                            </Stack>
                        </Stack>
                        <AdsBanner slot={"1750138896"}></AdsBanner>

                        <Box sx={{ width: "100%", color: "text.secondary", fontSize: 12 }}>
                            <nav>
                                <Box
                                component="ul"
                                sx={{
                                    listStyle: "none",
                                    margin: 0,
                                    padding: 0,
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "6px 12px",
                                }}
                                >
                                {links.map((item, idx) => (
                                    <Box component="li" key={idx} sx={{ display: "inline" }}>
                                    <Link
                                        href={item.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        underline="hover"
                                        sx={{
                                        color: "text.secondary",
                                        fontSize: 12,
                                        "&:hover": { color: "text.primary" },
                                        }}
                                    >
                                        {item.label}
                                    </Link>
                                    </Box>
                                ))}
                                </Box>
                            </nav>

                            {/* Footer text */}
                            <Typography
                                sx={{
                                mt: 2,
                                fontSize: 12,
                                color: "text.secondary",
                                }}
                            >
                                © 2025 FAMBI
                            </Typography>
                        </Box>
                        <Divider/>
                    </Stack>
                </Grid>
            </Grid>
                    
            {/* Confirmation Dialog */}
            <Dialog open={openDialogDelete} onClose={handleCancel}>
                <DialogTitle>¿Confirmar eliminación?</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    ¿Estás seguro de que deseas eliminar este registro? Esta acción no se puede deshacer.
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCancel}>Cancelar</Button>
                <Button onClick={handleConfirmDelete} color="error">
                    Eliminar
                </Button>
                </DialogActions>
            </Dialog>

            <CardexDialog
                open={openDialog}
                onClose={handleCloseDialog}
                onSubmit={handleSubmit}
                loading={loading}
                title="Agregar Cardex"
                columns={columns}
                extraProps={{
                    gender: { value: gender, onChange: handleChangeGender },
                    secure: { value: secure, onChange: handleChangeSecure },
                    sexually_transmitted_disease: { value: selectedStd, onChange: handleChangeStd },
                    chronic_degenerative_diseases: { value: selectedCdd, onChange: handleChangeCdd },
                    sport: { value: selectedSports, onChange: handleChangeSports },
                    civil_state: { value: civilState, onChange: handleChangeCivilState },
                    drug_allergy: { value: selectedDrugAllergies, onChange: handleChangeDrugAllergies },
                    common_allergies: { value: selectedAllergies, onChange: handleChangeAllergies },
                    disabilities: { value: selectedDisabilities, onChange: handleChangeDisabilities },
                    blood_type: { value: selectedBlood, onChange: handleChangeBlood },
                    setAddress1,
                    contacts,
                    setContacts,
                }}
            />

            <UserDialog
                open={openUserDialog}
                onClose={handleCloseUserDialog}
                onSubmit={handleUserSubmit}
                loading={loading}
                title="Agregar tutorado"
                columns={columnsUser}
                extraProps={null}
            />
                        
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbarState.open} onClose={handleCloseSnackBar}>
                <Alert
                    onClose={handleCloseSnackBar}
                    severity={snackbarState.status}
                    variant="filled"
                >
                    {snackbarState.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default Sons;
